import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid, Cell} from "react-md";

class AutoScalingDataGrid extends Component {
  constructor(props) {
    super(props);
    this.formatCell = this.formatCell.bind(this);
  }

  formatCell(item) {
    if(item.type.toUpperCase().includes("EMAIL")) {
      return(  <a href={"mailto:" + item.value}>{item.value}</a>);
    }
    else {
      return(item.value);
    }
  }

  render() {
    if(this.props.items !== [] && this.props.columns.length !== undefined)
      return (
        <div>
            {
                this.props.items.map((item, i) => {
                  return (
                    <Grid className="md-grid--no-spacing" style={{width: "100%"}}key={"row" + i}>
                      <Cell className="contactCell" key={"type" + i} size={4}>{item.type}</Cell>
                      <Cell className="contactCell padLeft boldText" key={"value" + i} size={8}>{this.formatCell(item)}</Cell>
                    </Grid>);
            })
          }
        </div>
      );
      return null;
  }



}

AutoScalingDataGrid.propTypes = {
  columns: PropTypes.array,
  items: PropTypes.array,
};

export default AutoScalingDataGrid;